import { HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { AggregationsModel, AggregationsType } from "src/app/models/api/aggregations.model";
import { IntegrationDataFlowModel } from "src/app/models/api/integrationDataFlow.model";
import { ISelectedFilters } from "src/app/models/filters/selectedFilters.interface";
import { HttpService } from "../http/http.service";

@Injectable({
    providedIn: "root",
})
export class AggregationsHttpServiceService {
    /**
     * The aggregations base url
     * @private
     * @readonly
     */
    private readonly _aggregationsBaseUrl: string = "aggregations";

    constructor(private _httpService: HttpService) {}

    /**
     * @public Get integrations
     * @returns an Observable{integrationModel} with the integrations returned from server
     */
    public getAggregations(aggregationsType: AggregationsType, filterOptions?: ISelectedFilters): Observable<AggregationsModel> {
        const url = `${this._aggregationsBaseUrl}/${aggregationsType}`;
        const httpParams = this._createAggregationsQueryParams(filterOptions);

        return this._httpService.get<AggregationsModel>(url, undefined, httpParams);
    }

    /**
     * @public Get integrations' data flow aggregations
     * @returns an Observable{IntegrationDataFlowModel} with all the integrations data flow returned from server
     */
    public getIntegrationsDataflow(): Observable<IntegrationDataFlowModel> {
        const url = `${this._aggregationsBaseUrl}/integrations/dataflow`;
        return this._httpService.get<IntegrationDataFlowModel>(url);
    }

    private _createAggregationsQueryParams(filterOptions?: ISelectedFilters) {
        let httpParams = new HttpParams();
        if (filterOptions === undefined) return httpParams;

        if (filterOptions.integration && filterOptions.integration.length > 0) {
            httpParams = httpParams.append("integrationId", filterOptions.integration.join(","));
        }

        if (filterOptions.policy && filterOptions.policy.length > 0) {
            httpParams = httpParams.append("policyId", filterOptions.policy.join(","));
        }

        return httpParams;
    }
}
